module.exports = __webpack_public_path__ + "static/media/tagesschau24.0f7ff5b8.svg";